import React, { useEffect } from "react";
import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import { getTableColumns, getTableData } from "../../models/userModel"; // Adjust to user models
import Table from "../../components/common/table/Table";
import ActionDropdown from "../../components/actions/ActionDropdown";
import { deleteUser, fetchUsers, resetCreateStatus, resetUpdateStatus } from "../../store/user-slice";
import {useSearchParams} from "react-router-dom";


const UserView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const {
        items: users,
        fetchStatus,
        createStatus,
        updateStatus,
        pagination,
        error
    } = useSelector(state => state.user); // Adjust selector to your user slice

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchUsers({page: initialPage, limit: initialLimit}));
    }, [dispatch,initialPage,initialLimit]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteUser(id)); // Ensure this action matches your Redux action for deleting users
    };

    const tableColumns = getTableColumns({ ActionDropdown, deleteHandler }); // Ensure this function is set for user data
    const tableData = getTableData({ items: users }); // Adjust the parameters as needed based on your data structure

    return (
        <>
            <SubHeader title="All Users">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && <Table className="mobile-responsive" columns={tableColumns} data={tableData} pagination={pagination} />}
        </>
    );
};

export default UserView;
